<template>
  <div>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="12" class="mb-6 mt-6">
        <h4><strong>{{ equipe.equipe }}</strong></h4>
      </SGPColComponent>
    </SGPRowComponent>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="6">
        <h4 class="mb-6 mt-6">Responsaveis</h4>
      </SGPColComponent>
    </SGPRowComponent>
    <SGPRowComponent no-gutters>
      <EquipeResponsaveisComponent v-for="(responsavel, index) in equipe.ctrl_equipe_responsavel" :key="index"
        :responsavel="responsavel" />
      <SGPAlertaComponent v-if="!equipe.ctrl_equipe_responsavel.length">Nenhum responsavel associado</SGPAlertaComponent>
    </SGPRowComponent>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="6">
        <h4 class="mb-6 mt-6">Participantes</h4>
      </SGPColComponent>
    </SGPRowComponent>
    <SGPRowComponent no-gutters>
      <EquipeParticipantesComponent v-for="(participante, index) in equipe.ctrl_equipe_user" :key="index"
        :participante="participante" />
      <SGPAlertaComponent v-if="!equipe.ctrl_equipe_user.length">Nenhum participante associado</SGPAlertaComponent>
    </SGPRowComponent>
  </div>
</template>

<script>
import EquipeResponsaveisComponent from "./EquipeResponsaveisComponent.vue";
import EquipeParticipantesComponent from "./EquipeParticipantesComponent.vue";


export default {
  components: { EquipeResponsaveisComponent, EquipeParticipantesComponent },

  name: "EquipeComponent",

  props: {
    equipe: {
      type: Object,
      required: false
    }
  },
}
</script>